// extracted by mini-css-extract-plugin
export var tariffPage = "tariff-page-module--tariff-page--g-fz7";
export var tariffPage_support = "tariff-page-module--tariff-page_support--E3+wa";
export var tariffPage_outsource = "tariff-page-module--tariff-page_outsource--q1PUE";
export var tariffPage_customer = "tariff-page-module--tariff-page_customer--q6Jo+";